import { useState } from 'react'

import type { CartContextData } from '~/contexts/CartContext'
import { CartContext } from '~/contexts/CartContext'
import type { InventoryContextData } from '~/contexts/InventoryContext'
import { InventoryContext } from '~/contexts/InventoryContext'
import type { MediaManagerContextData } from '~/contexts/MediaManagerContext'
import { MediaManagerContext } from '~/contexts/MediaManagerContext'
import type { VisibilityStepsContextData } from '~/contexts/VisibilityStepsContext'
import { VisibilityStepsContext } from '~/contexts/VisibilityStepsContext'

import { NavbarContextProvider } from './navbar'
import { ThemeCustomizerContextProvider } from './theme-customizer'

interface ShopLayoutProvidersProps {
  children: React.ReactNode
}

export const ShopLayoutProviders = ({ children }: ShopLayoutProvidersProps) => {
  const [mediaManagerContext, setMediaManagerContext] =
    useState<MediaManagerContextData>({
      isOpen: false,
      intent: 'upload_attachments',
    })

  const [inventoryContext, setInventoryContext] =
    useState<InventoryContextData>({
      isOpen: false,
    })

  const [cartContext, setCartContext] = useState<CartContextData>({
    isOpen: false,
  })

  const [visibilityStepsContext, setVisibilityStepsContext] =
    useState<VisibilityStepsContextData>({ isOpen: false })

  return (
    <MediaManagerContext value={[mediaManagerContext, setMediaManagerContext]}>
      <InventoryContext value={[inventoryContext, setInventoryContext]}>
        <CartContext value={[cartContext, setCartContext]}>
          <VisibilityStepsContext
            value={[visibilityStepsContext, setVisibilityStepsContext]}
          >
            <ThemeCustomizerContextProvider>
              <NavbarContextProvider>{children}</NavbarContextProvider>
            </ThemeCustomizerContextProvider>
          </VisibilityStepsContext>
        </CartContext>
      </InventoryContext>
    </MediaManagerContext>
  )
}
